import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";

export default function VerifyEmailPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("pending"); // pending | success | error

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }
    api.get(`/auth/verify-email?token=${token}`)
      .then(() => setStatus("success"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="verify-email-page">
      {status === "pending" && (
        <>
          <Loader2 className="h-10 w-10 text-[#4ba3b7] mx-auto mb-4 animate-spin" />
          <p className="text-[#2B2B2B]/70" data-testid="verify-email-pending-message">{t("auth.verifyEmailPending")}</p>
        </>
      )}
      {status === "success" && (
        <>
          <CheckCircle2 className="h-12 w-12 text-[#34C759] mx-auto mb-4" />
          <h1 className="font-heading text-xl font-bold mb-2">{t("auth.verifyEmailTitle")}</h1>
          <p className="text-[#2B2B2B]/70 mb-6" data-testid="verify-email-success-message">{t("auth.verifyEmailSuccess")}</p>
          <Button asChild className="bg-[#4ba3b7] hover:bg-[#3D8A9A] rounded-xl h-12" data-testid="verify-email-login-link">
            <Link to="/login">{t("auth.loginButton")}</Link>
          </Button>
        </>
      )}
      {status === "error" && (
        <>
          <XCircle className="h-12 w-12 text-[#FF3B30] mx-auto mb-4" />
          <p className="text-[#2B2B2B]/70" data-testid="verify-email-error-message">{t("auth.verifyEmailError")}</p>
        </>
      )}
    </div>
  );
}
